// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#navbar_container {
  position: fixed;
  top: 0;
  left: 0;
  height: 5rem;
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  align-items: center;
  background-color: rgb(255, 255, 255);
  z-index: 2;
  box-shadow: 0 2px 10px -1px rgba(0, 0, 0, 0.25);
  opacity: 90%;
  overflow-y: hidden;
  background: black;
}

.logo {
  height: 4rem;
  margin-left: 2px;
}

.navbar_links_container {
  display: flex;
  justify-content: space-evenly;
  height: 2rem;
  width: 35%;
  cursor: pointer
}

.navbar_link_container {
  height: 2rem;
  margin: 0 1rem;
}

.navbar_link {
  height: 2rem;
  position: relative;
  text-decoration: none;
  display: block;
  font-size: 1.1rem;
  padding-top: 6px;
  /* color: rgb(94, 94, 94); */
  color: rgb(255, 255, 255);

}

.navbar_link:hover {
  font-weight: bold;
}

.navbar_link::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  left: 0;
  /* background-color: rgb(59, 59, 59); */
  background-color: rgb(255, 255, 255);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.navbar_link:hover::before {
  transform: scaleX(1);
}

.navbar_link.active {
  font-weight: bold;
}

.navbar_link.active::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  left: 0;
  /* background-color: rgb(59, 59, 59); */
  background-color: rgb(255, 255, 255);
  transform: scaleX(1);
}

.navbar_contact_button_container {
  right: 0;
  width: 8rem;
  margin-right: 1rem;
}

.navbar_contact_button {
  height: 34px;
  width: 100%;
  border-radius: 3px;
  border: 1px solid white;
  font-size: 1.1rem;
  cursor: pointer;
  background-color: rgb(0, 0, 0);
  color: white;
  line-height: 2rem;
  transition: transform 0.2s ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.navbar_contact_button:hover {
  background-color: white;
  color: black;
  animation: pulse 1s infinite;
}


@media only screen and (max-width: 768px) {

  #navbar_container {
    padding: 0 0.5rem;
    height: 4rem;
  }

  .logo {
    height: 4rem;
    margin: 0;

  }

  .mobile_nav_icon {
    position: absolute;
    right: 1rem;
    width: 2.2rem;
  }

  .hide_nav_icon {
    display: none;
  }

  .navbar_links_container {
    width: 100%;
  }

  .navbar_link_container {
    margin: 0 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/navbar/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,UAAU;EACV,+CAA+C;EAC/C,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;;AAE3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,OAAO;EACP,uCAAuC;EACvC,oCAAoC;EACpC,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,OAAO;EACP,uCAAuC;EACvC,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;AAC9B;;;AAGA;;EAEE;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,SAAS;;EAEX;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["#navbar_container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 5rem;\n  width: 100%;\n  max-width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 1rem;\n  align-items: center;\n  background-color: rgb(255, 255, 255);\n  z-index: 2;\n  box-shadow: 0 2px 10px -1px rgba(0, 0, 0, 0.25);\n  opacity: 90%;\n  overflow-y: hidden;\n  background: black;\n}\n\n.logo {\n  height: 4rem;\n  margin-left: 2px;\n}\n\n.navbar_links_container {\n  display: flex;\n  justify-content: space-evenly;\n  height: 2rem;\n  width: 35%;\n  cursor: pointer\n}\n\n.navbar_link_container {\n  height: 2rem;\n  margin: 0 1rem;\n}\n\n.navbar_link {\n  height: 2rem;\n  position: relative;\n  text-decoration: none;\n  display: block;\n  font-size: 1.1rem;\n  padding-top: 6px;\n  /* color: rgb(94, 94, 94); */\n  color: rgb(255, 255, 255);\n\n}\n\n.navbar_link:hover {\n  font-weight: bold;\n}\n\n.navbar_link::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  bottom: 0;\n  left: 0;\n  /* background-color: rgb(59, 59, 59); */\n  background-color: rgb(255, 255, 255);\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.navbar_link:hover::before {\n  transform: scaleX(1);\n}\n\n.navbar_link.active {\n  font-weight: bold;\n}\n\n.navbar_link.active::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  bottom: 0;\n  left: 0;\n  /* background-color: rgb(59, 59, 59); */\n  background-color: rgb(255, 255, 255);\n  transform: scaleX(1);\n}\n\n.navbar_contact_button_container {\n  right: 0;\n  width: 8rem;\n  margin-right: 1rem;\n}\n\n.navbar_contact_button {\n  height: 34px;\n  width: 100%;\n  border-radius: 3px;\n  border: 1px solid white;\n  font-size: 1.1rem;\n  cursor: pointer;\n  background-color: rgb(0, 0, 0);\n  color: white;\n  line-height: 2rem;\n  transition: transform 0.2s ease-in-out;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.1);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n.navbar_contact_button:hover {\n  background-color: white;\n  color: black;\n  animation: pulse 1s infinite;\n}\n\n\n@media only screen and (max-width: 768px) {\n\n  #navbar_container {\n    padding: 0 0.5rem;\n    height: 4rem;\n  }\n\n  .logo {\n    height: 4rem;\n    margin: 0;\n\n  }\n\n  .mobile_nav_icon {\n    position: absolute;\n    right: 1rem;\n    width: 2.2rem;\n  }\n\n  .hide_nav_icon {\n    display: none;\n  }\n\n  .navbar_links_container {\n    width: 100%;\n  }\n\n  .navbar_link_container {\n    margin: 0 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
